import { ApolloProvider } from "@apollo/client";
import { ConfigProvider } from "antd";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import App from "./App.tsx";
import { Auth0ProviderWithNavigate } from "./auth/auth0-provider-with-navigate.tsx";
import { AuthenticationGuard } from "./auth/authentication-guard.tsx";
import { AuthContextProvider } from "./contexts/auth/provider.tsx";
import { ToastContextProvider } from "./contexts/toast/provider.tsx";
import {
  MessageFromAddInType,
  subscribeToMessageType,
} from "./helpers/window-events.ts";
import "./i18n";
import { apolloClient } from "./tools/apollo.ts";
import initSentry from "./tools/sentry.ts";

initSentry();

subscribeToMessageType(MessageFromAddInType.GO_TO_SUBSCRIPTION, (event) => {
  if (event.data?.type === MessageFromAddInType.GO_TO_SUBSCRIPTION) {
    window.location.href = "/subscription";
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <>
      <BrowserRouter>
        <ConfigProvider
          theme={{
            token: {
              colorError: "#F0497B",
              colorSuccess: "#0CD7A5",
              colorPrimary: "#7333FF",
            },
          }}
        >
          <Auth0ProviderWithNavigate>
            <ApolloProvider client={apolloClient}>
              <AuthContextProvider>
                <ToastContextProvider>
                  {<AuthenticationGuard component={App} />}
                </ToastContextProvider>
              </AuthContextProvider>
            </ApolloProvider>
          </Auth0ProviderWithNavigate>
        </ConfigProvider>
      </BrowserRouter>
      <Tooltip id="jane-tooltip" />
    </>
  </React.StrictMode>
);
